import { t } from '@avalara/bat-apps-shared/i18n';
import { SDialog, SIcon } from '@avalara/skylab-sdk/react';

import { AdminAccessDialogWrapper } from '../../styled/components/product-catalog/admin-access-dialog-wrapper';

type Props = {
  open: boolean;
  onDismiss: () => void;
};

const handleCopyLink = async () => {
  if (!navigator.clipboard?.writeText) return;

  try {
    await navigator.clipboard.writeText(window.location.href);
  } catch {
    // Clipboard access is unavailable or was denied.
  }
};

// Shared by pricing-tiers.tsx and hero.tsx — a PDP only ever renders one of those two CTA
// surfaces at a time (see the hero-only vs. tiers-only comment in sales-tax-registrations.ts), so
// each caller keeps its own local `open` state rather than lifting it here.
const AdminAccessDialog = ({ open, onDismiss }: Props) => (
  <AdminAccessDialogWrapper>
    <SDialog
      id='product-detail-admin-access-dialog'
      data-ref='buy.product-detail.admin-access-dialog'
      onS-dismiss={onDismiss}
      open={open}
    >
      <div slot='header' data-ref='buy.product-detail.admin-access-dialog.header'>
        {t('client.product-detail.admin-access-dialog.title')}
      </div>
      <div slot='body' data-ref='buy.product-detail.admin-access-dialog.body'>
        {t('client.product-detail.admin-access-dialog.body')}
      </div>
      <div slot='footer' data-ref='buy.product-detail.admin-access-dialog.footer'>
        <span className='flex'>
          <button
            type='button'
            className='primary'
            data-ref='buy.product-detail.admin-access-dialog.copy-link-button'
            onClick={handleCopyLink}
          >
            <SIcon name='copy' aria-hidden='true' />
            {t('client.product-detail.admin-access-dialog.copy-link')}
          </button>
          <button
            type='button'
            className='secondary margin-left-sm'
            data-ref='buy.product-detail.admin-access-dialog.cancel-button'
            onClick={onDismiss}
          >
            {t('client.product-detail.admin-access-dialog.cancel')}
          </button>
        </span>
      </div>
    </SDialog>
  </AdminAccessDialogWrapper>
);

export default AdminAccessDialog;
